import { z } from 'zod'
import { ZugmeldestelleSchema } from '../../Generic/schema/generic.schema'

// Default constants
const DEFAULT_AUFTRAG27_10 = {
  enabled: true,
  feld27_11: {
    art: '' as const,
    name: ''
  },
  feld27_12: {
    art: '' as const,
    name: ''
  }
}

const DEFAULT_BEFEHL_27_FORM = {
  auftrag27_10: DEFAULT_AUFTRAG27_10
}

// Schema definitions
const Auftrag27_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG27_10.enabled),
    feld27_11: ZugmeldestelleSchema,
    feld27_12: ZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG27_10))

// Base schema
const Befehl27FormSchemaBase = z
  .object({
    auftrag27_10: Auftrag27_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_27_FORM))

export const Befehl27FormSchema = Befehl27FormSchemaBase

// Validation schema factory
export const createBefehl27FormValidationSchema = () => {
  return Befehl27FormSchemaBase
}

export type Befehl27FormData = z.infer<typeof Befehl27FormSchemaBase>
